export default __webpack_public_path__ + "static/media/ic_edit_pencil.2a805eab.svg";